import Vue from "vue";
import Vuex from "vuex";
import searchedChart from "./modules/searched-chart";
import locale from "./modules/locale-i18n";
import cindex from "./modules/cindex";
import statistic from "./modules/statistic.store";
import article from "./modules/article.store";
import industry from "./modules/industry.store";
import overview from "./modules/overview-table";
import chart from "./modules/charts.store";
import site from "./modules/site.store";
import banner from "./modules/banner.store";
import power_bi from "./modules/power-bi.store";
import DevData from "@/store/modules/DeveloperData";
// import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    searchedChart,
    locale,
    statistic,
    article,
    cindex,
    overview,
    industry,
    chart,
    site,
    banner,
    power_bi,
    DevData,
  },
  // strict: debug,
  // plugins: [ createPersistedState() ]
});
